export default {
    "maia_chatbot_open_message_lite": "¡Hola! Soy {name}, tu asistente virtual.",
    "maia_chatbot_open_message_lite_with_account": "¡Hola! Soy {name}, asistente virtual de {accountName}.",
    "maia_chatbot_alertMessage": "¡Hola! Soy {name}, tu asistente virtual.",
    "maia_chatbot_open_message": "¡Hola! Soy {name}, tu asistente virtual.",
    "maia_chatbot_open_message_with_account": "¡Hola! Soy {name}, asistente virtual de {accountName}.",
    "maia_chatbot_welcomeMessage": "¡Hola! Soy {name}, tu asistente virtual.",
    "maia_chatbot_follow_message": "Elige una opción o escribe tu consulta.",
    "maia_virtual_assistant": "{name} - Asistente Virtual",
    "maia_chatbot_input_placeholder": "Escribe tu mensaje...",
    "send": "Enviar",
    "maia_chatbot_skill_see_more": "Ver más",
    "maia_chatbot_promotion_includes": "Incluye:",
    "maia_chatbot_promotion_terms_and_conditions": "Términos y condiciones:",
    "maia_chatbot_promotion_see_promotion": "Ver promoción",
    "maia_chatbot_promotion_min_rate": "Tarifa desde {minRate}",
    "maia_chatbot_book": "Reservar",
    "maia_chatbot_skill_itinerary_title": "Reservación {name}",
    "maia_chatbot_skill_itinerary_reserved_for": "Reservado para:",
    "maia_chatbot_skill_itinerary_status_CONFIRMED": "Confirmado",
    "maia_chatbot_skill_itinerary_status_PENDING": "Pendiente",
    "maia_chatbot_skill_itinerary_status_CANCELLED": "Cancelado",
    "maia_chatbot_skill_itinerary_see_full_itinerary": "Ver itinerario completo",
    "maia_chatbot_skill_map_title": "Ubicación",
    "maia_chatbot_skill_map_directions_button": "Obtener indicaciones",
    "maia_chatbot_skill_itinerary_ota_message": "Esta reservación fue realizada a través de una agencia de viajes en línea ({otaName}). Para más detalles, por favor revisa tu correo electrónico o contacta a {otaName} directamente.",
    "maia_chatbot_skill_rating_thanks": "¡Gracias!",
    "maia_chatbot_skill_rating_error": "Por favor, intenta de nuevo"
};
